<template>
  <div>
    <Modal >
      <form @submit.prevent="onSubmit">
        <div class="title"> {{ !editar ? 'Crear nueva reclamación' : 'Información de la reclamacion' }}</div>

        <div v-if="!editar">
          <div class="alert alert-primary mx-3 my-3" role="alert">
            <i class="fa-solid fa-circle-info"></i>
            Para garantizar que la generación de la reclamación se procese adecuadamente, por favor, asegúrate de proporcionar
            información completa y precisa en todos los campos del formulario.
          </div>
        </div>

        <div class="body">

          <div  v-if="pagina === 1">
            <h5>
              Información general
              <br>
              <small class="text-secondary">(Paso 1/3)</small>
            </h5>

            <div class="row justify-center">

              <div class="col-md-4 my-3">
                <label for="trimestre_presentar">Trimestre</label>
                <select v-model="reclamacion.trimestre" name="trimestre_presentar" id="trimestre_presentar"
                        class="form-control" :disabled="!editable">
                  <option :value="num_trimestre" v-for="(trimestre, num_trimestre) of trimestres">{{trimestre}}</option>
                </select>
              </div>

              <div class="col-md-4 my-3">
                <label for="año_presentar">Año</label>
                <select v-model="reclamacion.trimestre_ano" name="año_presentar" id="año_presentar"
                        class="form-control" :disabled="!editable">
                  <option :value="ano_actual-1">{{ano_actual-1}}</option>
                  <option :value="ano_actual">{{ano_actual}}</option>
                </select>
              </div>

              <div class="col-md-4 my-3">
                <button type="button" class="btn btn-link btn-sm" data-toggle="popover" title="De acuerdo a la disposición siempre es el valor de “1”"><i class="fa fa-info-circle"></i></button>
                <label for="numero_reclamacion">Número de reclamación</label>
                <input v-model="reclamacion.numero_reclamacion" type="text" name="numero_reclamacion" id="numero_reclamacion"
                       class="form-control" disabled>
              </div>
            </div>

            <div class="row justify-center">

              <div class="col-md-6 my-3">
                <label for="fecha_reclamacion">Fecha de reclamación</label>
                <input v-model="reclamacion.fecha_reclamacion" type="date" name="fecha_reclamacion"
                       id="fecha_reclamacion" class="form-control" :disabled="!editable">
              </div>

              <div class="col-md-6 my-3">
                <label for="medio_de_recepcion">Medio de recepción</label>
                <select v-model="reclamacion.medio_de_recepcion" name="medio_de_recepcion"
                        id="medio_de_recepcion" class="form-control" :disabled="!editable">
                  <option v-for="medio in medios_recepciones" :value="medio.valor" :key="medio.valor">
                    {{ medio.nombre }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 my-3" v-if="reclamacion.medio_de_recepcion == 6 || reclamacion.medio_de_recepcion == 7">
                <label for="folio_condusef">Folio CONDUSEF</label>
                <input id="folio_condusef" type="text" class="form-control" v-model="reclamacion.folio_condusef" :disabled="!editable" maxlength="50">
              </div>

              <div class="col-md-6 my-3" v-if="reclamacion.medio_de_recepcion == 6">
                <label for="re">ReversaSIGE</label>
                <select v-model="reclamacion.reversaSIGE" name="reversaSIGE"
                        id="reversaSIGE" class="form-control" :disabled="!editable ">
                  <option value="0">NO es reversa SIGE (Gestión electrónica)</option>
                  <option value="1">Si es reversa SIGE (Gestión electrónica)</option>
                </select>
              </div>


              <div class="col-md-6 my-3">
                <label for="prioridad">Prioridad</label>
                <select v-model="reclamacion.prioridad" name="prioridad" id="prioridad" class="form-control"
                        :disabled="!editable">
                  <option value="SI">Si</option>
                  <option value="NO">No</option>
                </select>
              </div>

              <div class="col-md-6 my-3">
                <label for="estatus_reclamacion">Estado de la reclamación</label>
                <select v-model="reclamacion.estatus_reclamacion" name="estatus_reclamacion" id="estatus_reclamacion"
                        class="form-control" :disabled="!editable" @change="cambio_estatus_reclamacion()">
                  <option value="1">Pendiente</option>
                  <option value="2">Concluido</option>
                </select>
              </div>

              <div class="col-md-6 my-3">
                <button type="button" class="btn btn-link btn-sm" data-toggle="popover" title="El campo solo es requerido cuando el estatús de reclamación es concluido"><i class="fa fa-info-circle"></i></button>
                <label for="nivel_atencion">Nivel de atención</label>
                <select v-model="reclamacion.nivel_atencion" name="nivel_atencion"
                        id="nivel_atencion" class="form-control" :disabled="!editable || reclamacion.estatus_reclamacion == estatus_pendiente">
                  <option v-for="nivel in niveles_atenciones" :value="nivel.valor" :key="nivel.valor">
                    {{ nivel.nombre }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 my-3">
                <button type="button" class="btn btn-link btn-sm" data-toggle="popover" title="El campo solo es requerido cuando el estatús de reclamación es concluido"><i class="fa fa-info-circle"></i></button>
                <label for="fecha_atencion">Fecha de atención</label>
                <input v-model="reclamacion.fecha_atencion" type="date" name="fecha_atencion"
                       id="fecha_atencion" class="form-control" :disabled="!editable || reclamacion.estatus_reclamacion == estatus_pendiente">
              </div>

              <div class="col-md-6 my-3">
                <button type="button" class="btn btn-link btn-sm" data-toggle="popover" title="El campo solo es requerido cuando el estatús de reclamación es concluido"><i class="fa fa-info-circle"></i></button>
                <label for="sentido_de_resolucion">Sentido de resolución</label>
                <select v-model="reclamacion.sentido_de_resolucion" name="sentido_de_resolucion"
                        id="sentido_de_resolucion" class="form-control" :disabled="!editable ">
                  <option value="1">Totalmente favorable al usuario</option>
                  <option value="2">Desfavorable al Usuario</option>
                  <option value="3">Parcialmente favorable al usuario</option>
                </select>
              </div>

              <div class="col-md-6 my-3">
                <button type="button" class="btn btn-link btn-sm" data-toggle="popover" title="El campo solo es requerido cuando el estatús de reclamación es concluido"><i class="fa fa-info-circle"></i></button>
                <label for="fecha_resolucion">Fecha de resolución</label>
                <input v-model="reclamacion.fecha_resolucion" type="date" name="fecha_resolucion"
                       id="fecha_resolucion" class="form-control" :disabled="!editable || reclamacion.estatus_reclamacion == estatus_pendiente">
              </div>

              <div class="col-md-6 my-3">
                <button type="button" class="btn btn-link btn-sm" data-toggle="popover" title="El campo solo es requerido cuando el estatús de reclamación es concluido"><i class="fa fa-info-circle"></i></button>
                <label for="fecha_notificacion_usuario">Fecha de notificación usuario</label>
                <input v-model="reclamacion.fecha_notificacion_usuario" type="date" name="fecha_notificacion_usuario"
                       id="fecha_notificacion_usuario" class="form-control" :disabled="!editable || reclamacion.estatus_reclamacion == estatus_pendiente">
              </div>

            </div>
          </div>

          <div v-if="pagina === 2">


            <h5>
              Detalles de la reclamación
              <br>
              <small class="text-secondary">(Paso 2/3)</small>
            </h5>


            <div class="row justify-center">

              <div class="col-md-6 my-3">
                <label for="producto_servicio">Producto servicio</label>
                <select v-model="reclamacion.producto_servicio" name="producto_servicio"
                        id="producto_servicio" class="form-control" :disabled="!editable">
                  <option v-for="producto in productos_servicios" :value="producto.valor"
                          :key="producto.valor">
                    {{ producto.nombre }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 my-3">
                <label for="causa">Causa o motivo</label>
                <select v-model="reclamacion.causa" name="causa" id="causa"
                        class="form-control" :disabled="!editable">
                  <option v-for="causa in causas_financieras" :value="causa.valor">
                    {{ causa.nombre }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 my-3">
                <label for="tipo_persona">Tipo de Persona</label>
                <select v-model="reclamacion.tipo_persona" name="tipo_persona" id="tipo_persona" class="form-control"
                        :disabled="!editable"
                        @change="cambio_tipo_persona()"
                >
                  <option value="1">Persona Física</option>
                  <option value="2">Persona Moral</option>
                </select>
              </div>

              <template v-if="reclamacion.tipo_persona == persona_fisica">
                <div class="col-md-6 my-3">
                  <label for="sexo">Sexo</label>
                  <select v-model="reclamacion.sexo" name="sexo" id="sexo" class="form-control"
                          :disabled="!editable">
                    <option value="H">Hombre</option>
                    <option value="M">Mujer</option>
                  </select>
                </div>


                <div class="col-md-6 my-3">
                  <label for="edad">Edad</label>
                  <input v-model="reclamacion.edad" type="number" name="edad" id="edad" class="form-control"
                         :disabled="!editable">
                </div>
              </template>


              <div class="col-md-6 my-3">
                <label for="reclamacion_monetario">Reclamación monetaria</label>
                <select v-model="reclamacion.reclamacion_monetario" name="reclamacion_monetario" id="reclamacion_monetario" class="form-control"
                        :disabled="!editable"
                        @change="cambio_reclamacion_monetaria()"
                >
                  <option value="SI">SI</option>
                  <option value="NO">NO</option>
                </select>
              </div>

              <template v-if="reclamacion.reclamacion_monetario === 'SI'">

                <div class="col-md-6 my-3">
                  <label for="monto_reclamado">Monto reclamado</label>
                  <IC v-model="reclamacion.monto_reclamado" label="$" id="monto_reclamado" name="monto_reclamado" :formats="['moneyFormat']" :disabled="!editable"/>
                </div>

                <template v-if="reclamacion.estatus_reclamacion == estatus_concluido">
                  <!-- Los campos solo son requeridos si el estatus es concluido ( si no deben ser nulos) -->

                  <div class="col-md-6 my-3">
                    <button type="button" class="btn btn-link btn-sm" data-toggle="popover" title="El campo solo es requerido cuando cuando reclamación monetario es SI y el estatús de reclamación es concluido"><i class="fa fa-info-circle"></i></button>
                    <label for="importe_abonado">Importe abonado </label>
                    <IC v-model="reclamacion.importe_abonado" label="$" id="importe_abonado" name="importe_abonado" :formats="['moneyFormat']" :disabled="!editable"/>
                  </div>

                  <div class="col-md-6 my-3">
                    <button type="button" class="btn btn-link btn-sm" data-toggle="popover" title="El campo es requerido solo si el estatús de reclamación es concluido o el importe abonado es mayor a 0"><i class="fa fa-info-circle"></i></button>
                    <label for="fecha_abono_importe">Fecha de abono</label>
                    <input v-model="reclamacion.fecha_abono_importe" type="date" name="fecha_abono_importe"
                           id="fecha_abono_importe" class="form-control" :disabled="!editable">
                  </div>
                </template>

              </template>

            </div>
          </div>

          <div v-if="pagina === 3">


            <h5>
              Detalles de la reclamación
              <br>
              <small class="text-secondary">(Paso 3/3)</small>
            </h5>


            <div class="row justify-center">
              <div class="col-md-6 my-3">
                <button type="button" class="btn btn-link btn-sm" data-toggle="popover" title="El campo es requerido solo si el medio de recepción es UNE, Sucursal u Oficina de atención al público"><i class="fa fa-info-circle"></i></button>
                <label for="codigo_postal">Codigo postal</label>
                <input v-model="reclamacion.codigo_postal" @blur="buscar_codigo_postal" type="text"
                       maxlength="5" name="codigo_postal" id="codigo_postal" class="form-control"
                       :disabled="!editable">
              </div>

              <div class="col-md-6 my-3">
                <label for="entidad">Estado</label>
                <select v-model="reclamacion.entidad" name="entidad" id="entidad" class="form-control"
                        :disabled="!editable">
                  <option v-for="estado in estados" :value="estado.valor" :key="estado.valor">
                    {{ estado.nombre }}</option>
                </select>
              </div>


              <div class="col-md-6 my-3">
                <label for="municipio">Delegación / Municipio</label>
                <select v-model="reclamacion.municipio" name="municipio" id="municipio" class="form-control"
                        :disabled="!editable">
                  <option v-for="municipio in municipios" :value="municipio.valor" :key="municipio.valor">
                    {{ municipio.nombre }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 my-3">
                <label for="colonia">Colonia <small class="text-secondary">(opcional)</small> </label>
                <select v-model="reclamacion.colonia" name="colonia" id="colonia" class="form-control"
                        :disabled="!editable">
                  <option v-for="colonia in colonias" :value="colonia.valor" :key="colonia.valor">
                    {{ colonia.nombre }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 my-3">
                <label for="localidad">Localidad <small class="text-secondary">(opcional)</small></label>
                <select v-model="reclamacion.localidad" name="localidad" id="localidad" class="form-control"
                        :disabled="!editable">
                  <option v-for="localidad in localidades" :value="localidad.valor"
                          :key="localidad.valor">{{ localidad.nombre }}
                  </option>
                </select>
              </div>

            </div>


          </div>

        </div>

        <div class="footer">
          <div class="row">
            <div class="col-sm-12 text-right">
              <button class="btn btn-secondary mr-2" type="button" @click="anterior"
                      :disabled="pagina === 1">
                <i class="fa-solid fa-arrow-left"></i>
                Anterior
              </button>
              <button class="btn btn-primary mr-2" type="button" @click.prevent="show_modal_confirmar_crear = true"
                      v-if="(pagina === 3 && !reclamacion.id) || (reclamacion.id && evento_id)">
                <i class="fa-solid fa-floppy-disk"></i>
                {{ evento_id ? 'Actualizar' : 'Guardar' }}
              </button>

              <button class="btn btn-secondary mr-2" type="button" @click="siguiente"
                       v-if="pagina !== 3">
                Siguiente
                <i class="fa-solid fa-arrow-right"></i>
              </button>

              <br>
              <button class="btn btn-danger mt-3 mr-2" type="button" @click.prevent="$emit('close')">
                <i class="fa-solid fa-xmark"></i>
                Cancelar
              </button>
            </div>
          </div>
        </div>

      </form>

      <!--Modal Confirmar datos -->
      <Modal v-if="show_modal_confirmar_crear" :options="{ width: '30vw', type: 'danger' }">
        <div class="title"> <i class="fa fa-warning mr-2"></i> Mensaje importante</div>
        <div class="body">
          <h5 class="font-weight-bold">
            ¿Estás seguro de que todos los datos han sido cargados correctamente en el formulario?
          </h5>
        </div>
        <div class="footer">
          <div class="row">
            <div class="col-sm-12 text-right">
              <button class="btn btn-primary mr-2" type="button" @click.prevent="onSubmit">
                <i class="fa-solid fa-check"></i>
                Confirmar
              </button>
              <button class="btn btn-danger" type="button" @click.prevent="show_modal_confirmar_crear = false">
                <i class="fa-solid fa-xmark"></i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <!--Modal Confirmar datos  -->

    </Modal>
  </div>
</template>

<script>
import apiCatalogos from '@/apps/condusef/api/catalogos';
import apiSepomex from '@/apps/condusef/api/sepomex';
import apiCondusefReclamaciones from '@/apps/condusef/api/reclamaciones';
import Modal from '@/components/Modal';
import IC from "@/components/Form/InputCompuesto.vue";

export default {
  components: { Modal, IC },
  props: {
    prop_reclamacion: {
      type: Object,
      default() {
        return {
          folio_atencion: null
        }
      }

    },
  },
  data() {
    return {
      reclamacion: {
        trimestre:  null,
        trimestre_ano:  null,
        numero_reclamacion:  1,
        estatus_reclamacion:  null,
        fecha_reclamacion:  null,
        fecha_atencion:  null,
        medio_de_recepcion:  null,
        producto_servicio:  null,
        causa:  null,
        fecha_resolucion:  null,
        fecha_notificacion_usuario:  null,
        entidad:  null,
        codigo_postal:  null,
        municipio :  null,
        localidad:  null,
        colonia:  null,
        reclamacion_monetario:  null,
        monto_reclamado:  null,
        importe_abonado:  null,
        fecha_abono_importe:  null,
        prioridad:  null,
        tipo_persona:  null,
        sexo:  null,
        edad:  null,
        sentido_de_resolucion:  null,
        nivel_atencion:  null,
        folio_condusef:  null,
        reversaSIGE: null
      },
      editable: false,
      show_editar: null,
      evento_id: null,
      pagina: 1,
      medios_recepciones: [],
      productos_servicios: [],
      causas_financieras: [],
      niveles_atenciones: [],
      colonias: [],
      estados: [],
      municipios: [],
      localidades: [],
      show_modal_confirmar_crear: false,
      estatus_pendiente: 1,
      estatus_concluido: 2,
      persona_fisica: 1,
      persona_moral: 2,
      trimestres:  {1:'ENERO-MARZO', 2:'ABRIL-JUNIO', 3:'JULIO-SEPTIEMBRE', 4:'NOVIEMBRE-DICIEMBRE'}

    }
  },
  computed: {
    ano_actual(){
      return this.$moment().year()
    },
    //El trimestre que se debe presentar siempre va a ser el anterior al actual
    trimestre_activo() {
      if (this.editar)
        return {trimestre: this.prop_reclamacion.trimestre,  trimestre_ano: this.prop_reclamacion.trimestre_ano, label: this.prop_reclamacion.trimestre_label}


      const trimestre_actual = this.$moment().quarter()

      if (trimestre_actual === 1) {
        const trimestre_ano = this.ano_actual - 1;
        return {trimestre: 4, trimestre_ano: trimestre_ano, label: `${this.trimestres[4]} ${trimestre_ano}`}
      }

      const trimestre_activo = (trimestre_actual-1);

      return {
        trimestre: trimestre_activo, trimestre_ano: this.ano_actual,  label: `${this.trimestres[trimestre_activo]} ${this.ano_actual}`

      }
    }
    ,editar(){
      return !!this.prop_reclamacion.folio_atencion
    }
  },
  mounted() {
    if (this.editar) {
      this.reclamacion = this.$helper.clone(this.prop_reclamacion)
      this.editable = false;
      this.buscar_codigo_postal()
    } else {
      this.editable = true
      this.reclamacion.trimestre = this.trimestre_activo.trimestre
      this.reclamacion.trimestre_ano = this.trimestre_activo.trimestre_ano
    }

    this.obtener_catalogos();
  },
  methods: {
    anterior() {
      if (this.pagina > 1) {
        this.pagina--;
      }
    },
    siguiente() {
      if (this.pagina < 3) {
        this.pagina++;
      }
    },

    cambio_reclamacion_monetaria(){
      if (this.reclamacion.reclamacion_monetario == 'NO') {
        this.reclamacion.importe_abonado = null
        this.reclamacion.fecha_abono_importe = null
      }
    },

    cambio_estatus_reclamacion(){
      // si el estatus es pendiente los siguientes campos no son requeridos (se pasán a nulo)
      if (this.reclamacion.estatus_reclamacion == this.estatus_pendiente) {
        this.reclamacion.fecha_atencion = null
        this.reclamacion.nivel_atencion = null
        this.reclamacion.fecha_resolucion = null
        this.reclamacion.fecha_notificacion_usuario = null

        this.reclamacion.importe_abonado = null
        this.reclamacion.fecha_abono_importe = null
      }


    }
    ,cambio_tipo_persona(){
      if (this.reclamacion.tipo_persona == this.persona_moral) {
        this.reclamacion.sexo = null;
        this.reclamacion.edad = null;
      }
  },
    async obtener_catalogos() {
      try {
        const catalogos = (await apiCatalogos.listar_catalogos_reune()).data;
        for (const catalogo of catalogos) {
          if (catalogo.codigo == 'medios_de_recepcion')
            this.medios_recepciones = catalogo.opciones;
          else if (catalogo.codigo == 'lista_de_productos_reclamaciones_reune')
            this.productos_servicios = catalogo.opciones;
          else if (catalogo.codigo == 'niveles_de_atencion')
            this.niveles_atenciones = catalogo.opciones;
        }
      } catch (error) {
        this.$log.error('error', error);
        this.$helper.showAxiosError(error, 'Error');
      }
    },

    async buscar_codigo_postal() {
      try {
        const response = (await apiSepomex.codigos_postales(this.reclamacion.codigo_postal)).data;
        this.colonias = response.colonias
        this.estados = response.estados
        this.municipios = response.municipios
        this.localidades = response.localidades
      } catch (error) {
        this.$log.error('error', error);
        this.$helper.showAxiosError(error, 'Error');
      }
    },
    async obtener_casuas(){

        this.causas_financieras = []

        const url_options = {
          filters: [{
            relacion: "and",
            columna: "codigo",
            operador: "equal_to",
            valor1: 'reune_reclamaciones_causas_producto_' + this.reclamacion.producto_servicio,
            valor2: null
          }]
        }
        const response = (await apiCatalogos.listar_catalogos(url_options)).data[0]
        this.causas_financieras = response.opciones


    },
    async onSubmit() {

      this.show_modal_confirmar_crear = false;
      try {
        const response = (await apiCondusefReclamaciones.crear(this.reclamacion)).data
        this.$helper.showMessage('Crear Reclamación', 'Reclamación guardada exitosamente.', 'success', 'alert')

        this.$log.info('response', response);
        this.$emit('update');
      } catch (error) {
        this.$log.error('error', error);
        this.$helper.showAxiosError(error, 'Error');
      }
    },
  },

  watch: {
    'reclamacion.producto_servicio': {
      handler(newValue, oldValue) {
        if (!!newValue && newValue !== oldValue) {

          if (oldValue !== null)
              this.reclamacion.causa = null

          this.obtener_casuas()
        }
      }
    },
    'reclamacion.reclamacion_monetario': {
      handler(newValue, oldValue) {
        if (!!newValue && newValue !== oldValue) {

          if (newValue === 'NO')
            this.reclamacion.monto_reclamado = null
        }
      }
    }

  }
};

</script>